module.exports = {
    host: "https://bk.birlik.gold-uz.uz",
    // host: "http://localhost:8000",
    // host: "https://backend.gold-uz.uz",
};
